import React from 'react';
import { connect } from 'react-redux';

import OrganizationDetailComponent from '../../components/app/Organization/OrganizationDetail';

import * as actions from '../../actions/organization/organization-details';

const OrganizationDetail = (props) => {
  return (
    <OrganizationDetailComponent {...props} />
  );
};

export default connect(({ organization, user }) => ({ organizationDetails: organization.organizationDetails, user }), actions)(OrganizationDetail);
